import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { vessel } from '../Vessel';

export const useVesselMovements = () =>
  useQuery({
    queryKey: [QUERY_KEYS.vesselMovements],
    queryFn: async () => (await vessel.getVesselMovements()).data,
  });
